import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { PaginableResponseModel } from '../../../common/models/paginable-response.model';
import {
  SummaryCustomerAdvancePaymentListModel,
  SummaryCustomerAdvancePaymentModel
} from '../models/summary-customer-advance-payment.model';

@Injectable({ providedIn: 'root' })
export class CustomerAdvancePaymentService {
  private fullUrl = `${environment.apiUrl}/api/v2/customer-advance-payments`;

  constructor(private http: HttpClient) { }

  getSummaryList(
    filter: any
  ): Observable<PaginableResponseModel<SummaryCustomerAdvancePaymentModel> & { summary: SummaryCustomerAdvancePaymentListModel }> {
    return this.http.post<
      PaginableResponseModel<SummaryCustomerAdvancePaymentModel> & { summary: SummaryCustomerAdvancePaymentListModel }
    >(`${this.fullUrl}/list`, filter);
  }
}
